import { debounce } from '../../scripts/utils/debounce';
import replaceCartContent from '../cart/replaceCartContent';

if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.buttons = this.querySelectorAll('button');
      this.cartDrawer = document.getElementById('cart-drawer');
      if (this.cartDrawer) this.loadingEl = this.cartDrawer.querySelector('.loading');

      this.changeEvent = new Event('change', { bubbles: true });

      this.debouncedOnUpdateQuantity = debounce(() => {
        if (this.loadingEl) this.loadingEl.setAttribute('loading', '');
        this.updateQuantity();
      }, 300);

      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));

      this.isCartInput = this.classList.contains('cart_quantity_input');
    }

    connectedCallback() {
      this.validateQtyRules();
    }

    onInputChange(event) {
      this.validateQtyRules();
      const lineItemId = this.input.dataset.id;
      const quantity = this.input.value;
      this.debouncedOnUpdateQuantity();
    }

    async onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

      this.debouncedOnUpdateQuantity();
    }

    async updateQuantity() {
      if (this.isCartInput) {
        const lineItemId = this.input.dataset.id;
        const quantity = this.input.value;
        if (lineItemId && quantity) {
          await Shopify.functions.updateCart(lineItemId, quantity);
          await replaceCartContent();
          if (this.loadingEl) this.loadingEl.removeAttribute('loading');
        }
      }
    }

    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        const buttonMinus = this.querySelector("button[name='minus']");
        buttonMinus.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector("button[name='plus']");
        buttonPlus.classList.toggle('disabled', value >= max);
      }
    }
  }

  customElements.define('quantity-input', QuantityInput);
}
